<header aria-label="Site header" class="header">
  <nav class="header-container wrapper">

    <a href="https://www.stoke.gov.uk" class="logo">
      <img src="assets/images/stoke-logo.svg" alt="Stoke-on-Trent Site Logo">
    </a>

  </nav>
</header>
<nav class="nav-breadcrumb">
  <div class="wrapper">
    <ol>
      <li><a class="nav__link" href="https://www.stoke.gov.uk">Home</a></li>
    </ol>
  </div>
</nav>